import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating "back to top" button. Appears once the window is scrolled past a
// threshold; smooth-scrolls to the top on click. Global — mounted in Shell.
export default function ScrollToTop({ threshold = 400 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      setVisible(y > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      aria-label="Back to top"
      title="Back to top"
      data-testid="scroll-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-[90] w-11 h-11 grid place-items-center rounded-full border border-orange-500/40 bg-[#0F1A30]/90 backdrop-blur-md text-orange-200 shadow-[0_8px_30px_rgba(0,0,0,0.5)] transition-all duration-300 hover:bg-orange-500/20 hover:text-white hover:-translate-y-0.5 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
